import { useSyncExternalStore } from 'react';
import { createLiveUpdate } from '@delivery/shared/live-update';
import { isNative, loadUpdater, nativeAppVersion, onAppResume } from './native';

export type { CheckResult, UpdateStatus } from '@delivery/shared/live-update';

/** 构建时写进来的本包版本。没有(本地 dev、网页版)就不参与热更新 */
export const BUNDLE_VERSION: string = import.meta.env['VITE_BUNDLE_VERSION'] ?? 'dev';

/** 热更新(逻辑在 shared,和管理端共用;这里只接上司机端的原生适配层) */
const lu = createLiveUpdate({
  isNative,
  bundleVersion: BUNDLE_VERSION,
  updateUrl: import.meta.env['VITE_UPDATE_URL'] ?? '',
  loadUpdater,
  nativeAppVersion,
  onAppResume,
});

/** 这台设备能不能热更新:原生壳 + 构建时带了版本号和更新地址 */
export const liveUpdateEnabled = lu.enabled;
export const checkNow = lu.checkNow;
export const applyNow = lu.applyNow;
export const startLiveUpdate = lu.start;
export const dismissUpdate = lu.dismiss;

/** 更新状态(新版本就绪 / 要重装壳)—— 提示条和「检查更新」按钮共用 */
export function useUpdateStatus() {
  return useSyncExternalStore(lu.subscribe, lu.getStatus);
}
